export const visit = (vm, at) => {
vm(require("SharedI18nStrings/lang/languageNames/de.lyaml"));
at({ "de": { "videoData": { "time": { "abbreviations": { "hour": "Std.", "minute": "Min.", "second": "Sek." } } } } });
};